import {Layout, Anchor, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import CommunicationAP from './CommunicationAP';
import CommunicationColab from './CommunicationColab';
import CommunicationFP from './CommunicationFP';
import CommunicationImpact from './CommunicationImpact';
import CommunicationOC from './CommunicationOC';
import CommunicationOv from './CommunicationOv';

const {Link} = Anchor;
const {Sider} = Layout;
const {Text} = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const EducationLogic = () => {
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} style={{background: 'transparent'}}>
          <Link href='#CommunicationOv' title={<Text style={{color: appColors['ColorA']}}>Overview</Text>}/>
          <Link href="#CommunicationSM" title={<Text style={{color: appColors['ColorA']}}>Social Media</Text>}/>
          <Link href="#CommunicationColab" title={<Text style={{color: appColors['ColorA']}}>Collaborations</Text>}/>
          <Link href="#CommunicationAP" title={<Text style={{color: appColors['ColorA']}}>Activities with the Public</Text>}/>
          <Link href="#CommunicationImpact" title={<Text style={{color: appColors['ColorA']}}>Impact</Text>}/>
          <Link href="#CommunicationFP" title={<Text style={{color: appColors['ColorA']}}>Future Perspective</Text>}/>
          <Link href="#CommunicationOC" title={<Text style={{color: appColors['ColorA']}}>Overall Conclusions</Text>}/>
        </Anchor>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='CommunicationOv'>
              <CommunicationOv/>
            </div>
            <div id='CommunicationColab'>
              <CommunicationColab/>
            </div>
            <div id='CommunicationAP'>
              <CommunicationAP/>
            </div>
            <div id='CommunicationImpact'>
              <CommunicationImpact/>
            </div>
            <div id='CommunicationFP'>
              <CommunicationFP/>
            </div>
            <div id='CommunicationOC'>
              <CommunicationOC/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default EducationLogic;
